import React from 'react';
import WebApp from '@twa-dev/sdk';
import { Task } from '@/pages/Tasks/types';
import { Button } from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal';
import styles from './TaskActionModal.module.scss';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';

interface TaskActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  task: Task | null;
  onExecuteTask: () => void;
  onCheckTask: () => void;

  isProcessing: boolean;
}

const TaskActionModal: React.FC<TaskActionModalProps> = ({
  isOpen,
  onClose,
  task,
  onExecuteTask,
  onCheckTask,

  isProcessing,
}) => {
  if (!isOpen || !task) return null;

  const isDone = task.status === 'DONE';

  console.log('tasksssss', task);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className={styles.sheet}>
        <div className={styles.iconWrapper}>
          {task.icon ? (
            <img src={task.icon} alt={task.icon} />
          ) : (
            <div className={styles.defaultIcon}>
              {(() => {
                const title = task.title;
                for (let i = 0; i < title.length; i++) {
                  const char = title[i];
                  // Проверяем, является ли символ буквой или цифрой
                  if (/[a-zA-Zа-яА-Я0-9]/.test(char)) {
                    return char.toUpperCase();
                  }
                }
                // Если не найдено букв или цифр, возвращаем первый символ
                return title.charAt(0).toUpperCase();
              })()}
            </div>
          )}
        </div>
        <div className={styles.header}>
          <h3 className={styles.title}>{task.title}</h3>
        </div>
        <div className={styles.content}>
          {task.rewards?.stars && task.rewards.stars > 0 && (
            <div className={styles.reward}>
              <div className={styles.starIcon}>
                <StarIcon />
              </div>
              <div className={styles.rewardText}>{task.rewards.stars}</div>
            </div>
          )}
        </div>
        <div className={styles.task_instructions}>
          {task.instructions ? (
            <>
              {' '}
              {task.instructions?.map((instruction: string, index: number) => (
                <div className={styles.task_instructionItem} key={instruction}>
                  <div className={styles.instructionNumber}>{index + 1}</div>
                  {instruction}
                </div>
              ))}
            </>
          ) : (
            <>
              <div className={styles.task_instructionItem}>
                <div className={styles.instructionNumber}>{1}</div>
                Перейди на канал и подпишись
              </div>
              <div className={styles.task_instructionItem}>
                <div className={styles.instructionNumber}>{2}</div>
                Возвращайся в игру и забери награду
              </div>
            </>
          )}
        </div>
        <div className={styles.bottomLine}></div>
        <div className={styles.actions}>
          <>
            <button
              className={styles.actionButtonOrange}
              onClick={() => {
                if (WebApp && (WebApp as any).HapticFeedback) {
                  (WebApp as any).HapticFeedback.notificationOccurred(
                    'success',
                  );
                }
                onExecuteTask();
              }}
              disabled={isProcessing}
            >
              Открыть ссылку
            </button>
            <button
              className={styles.actionButton}
              onClick={() => {
                if (WebApp && (WebApp as any).HapticFeedback) {
                  (WebApp as any).HapticFeedback.notificationOccurred(
                    'success',
                  );
                }
                onCheckTask();
              }}
              disabled={isProcessing}
            >
              {isProcessing ? 'Проверяем...' : 'Проверить задание'}
            </button>
          </>
        </div>
      </div>
    </Modal>
  );
};

export default TaskActionModal;
